import { createSlice, PayloadAction } from '@reduxjs/toolkit';

// Add salesfloor slice
export interface SalesFloorState {
  manualMuteRoomOverride: boolean | null;
}

const salesFloorInitialState: SalesFloorState = {
  manualMuteRoomOverride: null,
};

export const salesFloorSlice = createSlice({
  name: 'salesFloor',
  initialState: salesFloorInitialState,
  reducers: {
    setManualMuteRoomOverride: (state, action: PayloadAction<boolean | null>) => {
      state.manualMuteRoomOverride = action.payload;
    },
  },
});

export const { setManualMuteRoomOverride } = salesFloorSlice.actions;

// Add user state conversion function
export const convertFromReduxSafeUserState = (state: any) => state;
